import * as React from 'react';
import { navigateToPage } from '../../../../utils/history';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageLevelError } from '../../../../components/form-elements/PageLevelError';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { AddressReviewRow } from '../components/AddressReviewRow';
import { AddressReviewSearchFilters } from '../../../../transportation/models/filters/address-review-search-filters';
import { Routes } from '../../../../utils/app-constants';
import { TransportationSvc } from '../../../../transportation/service';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';
import '../../../../transportation/styles.scss';

export const AddressesScene = (_props: any) => {
    const [errorMessage, setErrorMessage]           = React.useState('');
    const [service]                                 = React.useState(new TransportationSvc());
    const [filterParams, setFilterParams]           = React.useState(new AddressReviewSearchFilters());
    const [addresses, setAddresses]                 = React.useState(() => {
        const initial = new PagedApiResult<ShipToAddressRead>();
        initial.pagination = filterParams.paginationInfo;
        initial.pagination.reusePaging = true;
        return initial;
    });

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: AddressReviewSearchFilters) => {
        const response = await service.search(ShipToAddressRead, filters);
        if (response.status === StatusCode.Success) {
            setAddresses(response.data);
            setErrorMessage('');
        }
        else {
            setErrorMessage('Unable to load addresses.');
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm: any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        setFilterParams(new AddressReviewSearchFilters());
    };

    const handleAddressClick = (address: ShipToAddressRead) => {
        navigateToPage(`${Routes.APPROVALS_ADDRESSES}/${address.id}`);
    };

    return (
        <PageContent pageName={PageNames.TRANSPORTATION_ADDRESSES}>
            <PageBody>
                {errorMessage ? <PageLevelError message={errorMessage} /> : null}

                <PagedList
                    noResultsMessage="There are no pending approval addresses."
                    searchCallback={onSearch}
                    data={addresses}
                    filterProps={filterParams}
                    selectableClass=""
                    onFilterUpdate={onParamsUpdate}
                    onReset={onParamsReset}
                    hidePager={true}
                    rowRenderer={(address: ShipToAddressRead) =>
                        <AddressReviewRow
                            key={address.id}
                            address={address}
                            onClick={handleAddressClick}
                        />
                    }
                />
            </PageBody>
        </PageContent>
    );
};
